/* BrickSmart funnel config — products, VIP pricing + checkout link matrix.
   Modeled on the MBS Nutra config: cart.js reads everything from here. */

/* Build stamp — check in browser console to confirm which build is live */
window.BM_BUILD = "2026-10-22-lowstock-label";

/* Meta Conversions API relay (Cloudflare Worker). Leave "" to disable server-side events. */
window.BM_CAPI_URL = "https://bricksmart-capi.divine-agency333.workers.dev";

window.SITE = {
  brand: "BrickSmart",
  supportEmail: "help@bricksmart.store",
  guaranteeDays: 30
};

/* VIP Club — the one discount system on the site (mirrors MBS Subscribe & Save).
   once = standard price · vip = VIP Club price (25% off) · compare = strike-through */
window.BM_PRICING = {
  vipLabel: "BrickSmart VIP Club",
  vipSave: "25%",
  products: {
    falcon: {
      title: "Smuggler's Starfreighter (7005192)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/falcon-fal-p01.jpg?v=157718747983637988951793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/falcon-fal-p10.jpg?v=81733273165559946701793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 359.98, vip: 269.98 },
        bundle: { label: "Set + LED Light Kit", once: 419.98, vip: 314.98 }
      }
    },
    atat: {
      title: "Quad Assault Walker (7005313)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/atat-images-set_white.jpg?v=157288061734786276651793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/atat-images-p01.jpg?v=43482499095768031651793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 479.98, vip: 359.98 },
        bundle: { label: "Set + LED Light Kit", once: 527.98, vip: 395.98 }
      }
    },
    minas: {
      title: "The Tiered Citadel (1001377)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/minas-tirith-mt-p01.jpg?v=10491167093078940831793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/minas-tirith-mt-p11.jpg?v=76745875073849541841793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 419.98, vip: 314.98 },
        bundle: { label: "Set + LED Light Kit", once: 467.98, vip: 350.98 }
      }
    },
    pokemon: {
      title: "Trio of Starter Creatures (7002153)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/assets-p01.jpg?v=43984368160670230191793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/assets-p08.jpg?v=49829447768743417311793788909", ledPrice: 19.99,
      plans: {
        single: { label: "Set Only",            once: 419.98, vip: 314.98 },
        bundle: { label: "Set + LED Light Kit", once: 467.98, vip: 350.98 }
      }
    }
,
    colosseum: {
      title: "Colosseum (1000276)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/colosseum-img-p01.jpg?v=103328617097616677791793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/colosseum-img-p03.jpg?v=153807403753973768141793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 479.98, vip: 359.98 },
        bundle: { label: "Set + LED Light Kit", once: 539.98, vip: 404.98 }
      }
    },
    "barad-dur": {
      title: "The Shadow Fortress (1000333)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/barad-dur-img-p01.jpg?v=109615331467851954811793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/barad-dur-img-p07.jpg?v=74542861878391026831793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 299.98, vip: 224.98 },
        bundle: { label: "Set + LED Light Kit", once: 359.98, vip: 269.98 }
      }
    },
    rivendell: {
      title: "The Elven Valley Haven (1000316)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/rivendell-img-p01.jpg?v=152395078990046477331793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/rivendell-img-p07.jpg?v=52035343829722469511793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 335.98, vip: 251.98 },
        bundle: { label: "Set + LED Light Kit", once: 395.98, vip: 296.98 }
      }
    },
    "death-star": {
      title: "Collector Series Battle Station Sphere (7005419)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/death-star-img-p01.jpg?v=11237777252633575281793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/death-star-img-p07.jpg?v=48117850739273364301793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 551.98, vip: 413.98 },
        bundle: { label: "Set + LED Light Kit", once: 611.98, vip: 458.98 }
      }
    },
    "sail-barge": {
      title: "Desert Sail Barge (7005397)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/sail-barge-img-p01.jpg?v=19643860514936063331793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/sail-barge-img-p07.jpg?v=146733798455719289771793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 299.98, vip: 224.98 },
        bundle: { label: "Set + LED Light Kit", once: 347.98, vip: 260.98 }
      }
    },
    "star-destroyer": {
      title: "Imperial Star Cruiser (7005252)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/star-destroyer-img-p01.jpg?v=5749582243905640951793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/star-destroyer-img-p06.jpg?v=11625915020094910131793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 467.98, vip: 350.98 },
        bundle: { label: "Set + LED Light Kit", once: 515.98, vip: 386.98 }
      }
    },
    "porsche-gt3rs": {
      title: "Track Day GT Racer (4002056)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/porsche-gt3rs-img-p01.jpg?v=118930411055804048581793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/porsche-gt3rs-img-p06.jpg?v=176920430064447276941793788909",
      /* this set bundles a WALL MOUNT rather than a light kit */ ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",              once: 287.98, vip: 215.98 },
        bundle: { label: "Set + Wall Mount Display", once: 347.98, vip: 260.98 }
      }
    },
    "black-pearl": {
      title: "The Obsidian Galleon (1000365)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/black-pearl-img-p01.jpg?v=10856530554535200731793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/black-pearl-img-p08.jpg?v=59671823852990607441793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 269.98, vip: 202.48 },
        bundle: { label: "Set + LED Light Kit", once: 311.98, vip: 233.98 }
      }
    },
    koenigsegg: {
      title: "Master Series Nordic Sadair\u2019s Spear (4002232)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/koenigsegg-img-p01.jpg?v=148822683109960068701793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/koenigsegg-img-p05.jpg?v=86085502967705728971793788909",
      /* this set bundles a WALL MOUNT rather than a light kit */ ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",                 once: 249.98, vip: 187.48 },
        bundle: { label: "Set + Wall Mount Display", once: 289.98, vip: 217.48 }
      }
    },
    "mclaren-p1": {
      title: "British Track Hypercar (4002172)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/mclaren-p1-img-p01.jpg?v=97496221862564801431793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/mclaren-p1-img-p05.jpg?v=153876406047337505981793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",                 once: 249.98, vip: 187.48 },
        bundle: { label: "Set + Wall Mount Display", once: 289.98, vip: 217.48 }
      }
    },
    "red-bull-rb20": {
      title: "Navy Blue F1 Car (4002206)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/red-bull-rb20-img-p01.jpg?v=108961546045261098901793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/red-bull-rb20-img-p05.jpg?v=176505937760209186561793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 70.00,
      plans: {
        single: { label: "Set Only",                 once: 143.98, vip: 107.98 },
        bundle: { label: "Set + Wall Mount Display", once: 179.98, vip: 134.98 }
      }
    },
    "ferrari-sf24": {
      title: "Scarlet F1 Race Car (4002207)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/ferrari-sf24-img-p01.jpg?v=136769809167263241341793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/ferrari-sf24-img-p06.jpg?v=153707259604305085631793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 70.00,
      plans: {
        single: { label: "Set Only",                 once: 143.98, vip: 107.98 },
        bundle: { label: "Set + Wall Mount Display", once: 179.98, vip: 134.98 }
      }
    },
    "porsche-911-rsr": {
      title: "Endurance GT Racer (4002096)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/porsche-911-rsr-img-p01.jpg?v=30879899230329867281793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/porsche-911-rsr-img-p04.jpg?v=19464679613535077141793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 70.00,
      plans: {
        single: { label: "Set Only",                 once: 139.98, vip: 104.98 },
        bundle: { label: "Set + Wall Mount Display", once: 175.98, vip: 131.98 }
      }
    },
    gringotts: {
      title: "The Goblin Vault Bank — Collectors' Edition (7006417)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/gringotts-img-p01.jpg?v=173815624515409098011793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/gringotts-img-p08.jpg?v=136100931969205681711793788909", ledPrice: 50.00,
      plans: {
        single: { label: "Set Only",            once: 359.98, vip: 269.98 },
        bundle: { label: "Set + LED Light Kit", once: 407.98, vip: 305.98 }
      }
    },
    "enterprise-d": {
      title: "Galaxy-Class Starship (1000356)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/enterprise-d-img-p01.jpg?v=72382529470927075131793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/enterprise-d-img-p05.jpg?v=11000825383900464861793788909", ledPrice: 50.00,
      plans: {
        single: { label: "Set Only",            once: 335.98, vip: 251.98 },
        bundle: { label: "Set + LED Light Kit", once: 383.98, vip: 287.98 }
      }
    },
    "mercedes-w14": {
      title: "Silver F1 Race Car (4002171)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/mercedes-w14-img-p01.jpg?v=40097605617975618161793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/mercedes-w14-img-p05.jpg?v=89882444336618348921793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 70.00,
      plans: {
        single: { label: "Set Only",                 once: 143.98, vip: 107.98 },
        bundle: { label: "Set + Wall Mount Display", once: 179.98, vip: 134.98 }
      }
    },
    "bugatti-chiron": {
      title: "Grand Tourer Hypercar (4002083)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/bugatti-chiron-img-p01.jpg?v=27891749311652269381793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/bugatti-chiron-img-p06.jpg?v=91705939337944149511793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",                 once: 249.98, vip: 187.48 },
        bundle: { label: "Set + Wall Mount Display", once: 289.98, vip: 217.48 }
      }
    },
    "lamborghini-sian": {
      title: "Master Series Italian Bull Si\u00e1n FKP 37 (4002115)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/lamborghini-sian-img-p01.jpg?v=25193243251183366391793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/lamborghini-sian-img-p07.jpg?v=86280070910525392531793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",                 once: 249.98, vip: 187.48 },
        bundle: { label: "Set + Wall Mount Display", once: 289.98, vip: 217.48 }
      }
    },
    "ferrari-sp3": {
      title: "Scarlet Track Supercar (4002143)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/ferrari-sp3-img-p01.jpg?v=154891262005835185061793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/ferrari-sp3-img-p05.jpg?v=46180235533486692131793788909",
      /* car -> WALL MOUNT bundle, not a light kit */ ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",                 once: 249.98, vip: 187.48 },
        bundle: { label: "Set + Wall Mount Display", once: 289.98, vip: 217.48 }
      }
    },
    titanic: {
      title: "Titanic (1000294)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/titanic-img-p01.jpg?v=35143298659607591401793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/titanic-img-p07.jpg?v=170854731838700511651793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 389.98, vip: 292.48 },
        bundle: { label: "Set + LED Light Kit", once: 429.98, vip: 322.48 }
      }
    },
    "eiffel-tower": {
      title: "Eiffel Tower (1000307)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/eiffel-tower-img-p01.jpg?v=41660065375098699591793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/eiffel-tower-img-p06.jpg?v=171134411200708834451793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 389.98, vip: 292.48 },
        bundle: { label: "Set + LED Light Kit", once: 429.98, vip: 322.48 }
      }
    },
    "creel-house": {
      title: "The Haunted Manor (1001370)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/creel-house-img-p01.jpg?v=65030536331172748261793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/creel-house-img-p06.jpg?v=89316862732879370241793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 199.98, vip: 149.98 },
        bundle: { label: "Set + LED Light Kit", once: 239.98, vip: 179.98 }
      }
    },
    "upside-down": {
      title: "The Inverted Realm (7005810)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/upside-down-img-p01.jpg?v=2807738826011882251793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/upside-down-img-p08.jpg?v=111330195648437944571793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 249.98, vip: 187.48 },
        bundle: { label: "Set + LED Light Kit", once: 299.98, vip: 224.98 }
      }
    },
    "arkham-asylum": {
      title: "The Gothic Asylum (7006300)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/arkham-asylum-img-p01.jpg?v=71057930844798489721793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/arkham-asylum-img-p08.jpg?v=116587829489021037071793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 199.98, vip: 149.98 },
        bundle: { label: "Set + LED Light Kit", once: 229.98, vip: 172.48 }
      }
    },
    "sanctum-sanctorum": {
      title: "The Mystic Sanctum (7006218)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/sanctum-sanctorum-img-p01.jpg?v=153150602043422867191793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/sanctum-sanctorum-img-p08.jpg?v=110046563958793254571793788909", ledPrice: 50.00,
      plans: {
        single: { label: "Set Only",            once: 229.98, vip: 172.48 },
        bundle: { label: "Set + LED Light Kit", once: 249.98, vip: 187.48 }
      }
    },
    "x-mansion": {
      title: "The Academy Mansion (7006294)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/x-mansion-img-p01.jpg?v=137819526981703756661793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/x-mansion-img-p07.jpg?v=77996102463961680521793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 199.98, vip: 149.98 },
        bundle: { label: "Set + LED Light Kit", once: 239.98, vip: 179.98 }
      }
    },
    "avengers-tower": {
      title: "Guardian Tower (7006269)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/avengers-tower-img-p01.jpg?v=156162794233240112831793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/avengers-tower-img-p07.jpg?v=171259297871403182071793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 279.98, vip: 209.98 },
        bundle: { label: "Set + LED Light Kit", once: 309.98, vip: 232.48 }
      }
    },
    "daily-bugle": {
      title: "The City Newsroom (7006178)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/daily-bugle-img-p01.jpg?v=28028785635733108921793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/daily-bugle-img-p08.jpg?v=102284741562513951541793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 249.98, vip: 187.48 },
        bundle: { label: "Set + LED Light Kit", once: 279.98, vip: 209.98 }
      }
    },
    "ewok-village": {
      title: "Forest Tribe Village (1000236)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/ewok-village-img-p01.jpg?v=117616953660540421761793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/ewok-village-img-p05.jpg?v=160929018959779641021793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 249.98, vip: 187.48 },
        bundle: { label: "Set + LED Light Kit", once: 299.98, vip: 224.98 }
      }
    },
    "razor-crest": {
      title: "The Crest Gunship (7005331)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/razor-crest-img-p01.jpg?v=35427841389185006201793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/razor-crest-img-p06.jpg?v=56297489803914302031793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 339.98, vip: 254.98 },
        bundle: { label: "Set + LED Light Kit", once: 369.98, vip: 277.48 }
      }
    },
    "dropship-atot": {
      title: "Heavy Dropship & Carrier (1000195)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/dropship-atot-img-p01.jpg?v=20882647517826153891793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/dropship-atot-img-p01.jpg?v=20882647517826153891793788909", ledPrice: 0,
      /* SET ONLY — no light kit or display mount exists for this set, so no
         bundle plan is defined. cart.js skips the upsell when plans.bundle
         is absent, and the PDP hides the bundle offer. */
      plans: {
        single: { label: "Set Only", once: 199.98, vip: 149.98 }
      }
    },
    "porsche-911-targa": {
      title: "Classic Sports Coupe (1000295)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/porsche-911-targa-img-p01.jpg?v=120187658159741862011793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/porsche-911-targa-img-p06.jpg?v=179280023129060807381793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 99.98, vip: 74.98 },
        bundle: { label: "Set + LED Light Kit", once: 129.98, vip: 97.48 }
      }
    },
    venator: {
      title: "Attack Carrier Cruiser (7005367)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/venator-img-p01.jpg?v=71600686746568818621793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/venator-img-p06.jpg?v=86137048578426154551793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 379.98, vip: 284.98 },
        bundle: { label: "Set + LED Light Kit", once: 419.98, vip: 314.98 }
      }
    },
    "jango-starship": {
      title: "Collector Series the bounty hunter\u2019s Starship (7005409)",
      img: "//bricksmartorder.store/cdn/shop/t/11/assets/jango-starship-img-p01.jpg?v=29633037136334164691793788909",
      bundleImg: "//bricksmartorder.store/cdn/shop/t/11/assets/jango-starship-img-p06.jpg?v=58594499830419525491793788909", ledPrice: 30.99,
      plans: {
        single: { label: "Set Only",            once: 199.98, vip: 149.98 },
        bundle: { label: "Set + LED Light Kit", once: 229.98, vip: 172.48 }
      }
    }
  }
};

/* ===== VIP CLUB MEMBERSHIP =====
   The membership is a real Shopify subscription product. When the VIP toggle
   is on, cart.js adds this product to the Shopify cart with its selling plan
   attached, so Kaching creates the subscription and Shopify's automatic
   "Buy VIP Program → 25% off VIP Available" discount fires on the sets.
   - handle:  the product's URL slug in Shopify
   - price:   the recurring monthly charge, shown in the disclosure copy
   - planMatch: which selling plan to use if the product has more than one */
/* Shipping Protection — an optional add-on line, pre-selected in the cart.
   handle must match the Shopify product exactly. */
window.BM_SHIPPRO = {
  handle: "shipping-protection",
  price: 4.99,
  label: "Shipping Protection",
  blurb: "Protect from theft / loss / damage",
  defaultOn: true
};

window.BM_VIP = {
  handle: "vip-membership",
  price: 24.99,
  label: "BrickSmart VIP Club",

  /* ---- VIP IS LIVE, 1 CENT FIRST MONTH (2026-10-06) ---------------------
     firstMonthPrice 0 -> the first month is FREE, then $24.99/month (set 2026-10-14).
     2026-10-10: Phoenix owns the subscription, NOT Kaching. The membership
     therefore never becomes a Shopify cart line — Shopify only ever charges for
     the sets. The 25% is not a discount at all: each product carries a second
     variant ("Membership: VIP") priced 25% below Standard, and offerVariant()
     picks the tier from the toggle. Nothing to leak, nothing to expire.
     "line" -> the membership IS a Shopify cart line (Kaching-style). Unused.
     "phoenix" -> the membership NEVER becomes a Shopify cart line. The cart
     carries a VIP attribute; Phoenix reads it off the order and enrolls them.
     Shopify only ever charges for the sets, which is why expectedShopifyTotal()
     subtracts the membership before comparing against the drawer.
     Every surface that offers this must state the 1c, the $24.99 renewal and
     that it can be cancelled, in the same breath. That is not optional copy.
     2026-10-10: Phoenix owns the subscription, NOT Kaching. The membership
     therefore never becomes a Shopify cart line — Shopify only ever charges for
     the sets. The 25% is not a discount at all: each product carries a second
     variant ("Membership: VIP") priced 25% below Standard, and offerVariant()
     picks the tier from the toggle. Nothing to leak, nothing to expire.
     "line" -> the membership IS a Shopify cart line (Kaching-style). Unused.
     "phoenix" -> the membership NEVER becomes a Shopify cart line. We mark the
     cart with a VIP attribute; Phoenix reads it off the order and enrolls the
     customer into VIP Initial ($0 authorise, 30-day delay) -> VIP Recurring
     ($24.99/mo). Shopify only ever charges for the sets.
     firstMonthPrice 0 = the first month is free. The toggle is a real choice:
     off by default, and every surface that offers it must state the renewal
     price and that it can be cancelled, in the same breath. */
  mode: "phoenix",
  firstMonthPrice: 0,
  trialDays: 30,

  /* NO DISCOUNT OBJECT ANYWHERE. The 25% is a real second variant on every
     product ("Membership: VIP") priced 25% below the Standard variant, so the
     price the shopper sees IS the price Shopify charges. offerVariant() in
     cart.js picks the tier from the toggle. Nothing to leak, nothing to type,
     nothing to expire. Leave this empty. */
  discountCode: ""
};

/* ===== SHOPIFY STOREFRONT API — live checkout (the MBS Nutra pattern) =====
   Fill in these three fields and cart.js builds a fresh Shopify cart per
   checkout click, charging EXACTLY the price shown on the site.
   - domain: your store's .myshopify.com domain (e.g. "abc123.myshopify.com")
   - token:  Storefront API access token (Settings → Apps → Develop apps →
             your app → Storefront API. Public-safe by design.)
   - handles: the product handle (URL slug) of each set in Shopify.
   Each SET is two Shopify products — the Set Only product and the
   Set + LED Light Kit product — and each of those carries two variants for
   the membership tier, named "Standard" and "VIP" (the older
   "Set Only — VIP" style names still resolve too), priced exactly as the
   site displays. */
/* ---------------------------------------------------------------------------
   INVENTORY BADGE  (see stock.js)
   mode: "live" reads real stock from Shopify Storefront (quantityAvailable).
         "demo" generates a placeholder number — PRE-LAUNCH ONLY, must not ship
         to customers. Flip to "live" once inventory tracking + the
         unauthenticated_read_product_inventory scope are in place.
   threshold: badge hides above this many units (healthy stock shows nothing).
   pin:  fixed demo values, e.g. the Falcon stays where it is today.
--------------------------------------------------------------------------- */
/* ---------------------------------------------------------------------------
   HANDLING & FEES
   A real per-unit handling charge (3PL pick/pack). It is shown as its own line
   in the cart drawer and is included in the total the shopper sees before they
   ever reach checkout — never hidden, never rolled into a "total" without a
   line of its own.
   NOTE: listed set prices are set 1c below the Shopify price and this fee adds
   that cent back per unit, so the drawer total always equals what Shopify
   charges. If you change this amount, change the set prices to match, or the
   drawer and checkout will disagree.
--------------------------------------------------------------------------- */
window.BM_FEES = {
  /* RESTORED to 0.01 on 2026-09-10.
     The 38 PDPs carry their prices as hardcoded data-once / data-vip attributes
     in the .98 scheme (154 of them across 39 files) and do NOT read BM_PRICING.
     Zeroing this fee while raising BM_PRICING to .99 made the drawer read 1c
     ABOVE the PDP card with no line explaining it. The original design is
     coherent: PDP shows .98, drawer adds this cent as its own disclosed line,
     and the total equals what Shopify charges (.99).
     This is NOT the VIP first-month charge — that lives in BM_VIP and is 0. */
  handling: 0,
  label: "Handling & fees"
};

window.BM_STOCK_CONFIG = {
  /* -------------------------------------------------------------------------
     LOW-STOCK BADGE — mode + the dev team's hand-off point.

       "demo"   build aid. Invents a unit count and ticks it down on a timer.
                RUNS ON DEV / PREVIEW HOSTS ONLY (localhost, *.pages.dev,
                *.local, any host with staging/dev/preview/qa in the name).
                On bricksmart.store it renders NOTHING and logs why — an
                invented number must never reach a paying customer.
       "manual" shows counts{} below. A pid with no number shows no badge.
                On a preview host, a pid with no number falls back to the
                placeholder so the component is still visible while you work.
       "live"   reads real Shopify quantityAvailable via fetchLive() in
                stock.js. Needs inventory tracking ON for the product and
                `unauthenticated_read_product_inventory` on the Storefront
                token. This is the production target.

     DEV TEAM — two ways to make this real, pick either:
       1. Fill in counts{} below with actual units and set mode: "manual".
       2. Set mode: "live". fetchLive() is already written and documented at
          the top of stock.js; it only has to resolve {qty: Number|null}.
     Either way the render layer, thresholds, red <=3 state, hide-when-healthy
     and polling already work and need no changes.
  ------------------------------------------------------------------------- */
  mode: "label",

  /* ---- LABEL MODE — a standing notice, no number, no countdown ----
     Renders CFG.label with a red pulse. Nothing is generated and nothing
     decays; it says exactly this text until you change it.
     labelSets: null  = show on every set
                ["falcon","atat"]  = only these
     Keep it on the sets where it is true. */
  label:     "LOW STOCK \u2014 SELLING OUT SOON",
  labelSets: null,

  /* ---- SUPPLIER FEED (mode: "supplier") — the real-time production path ----
     DEV TEAM: point `endpoint` at a URL that returns live units from the
     supplier backend, set mode: "supplier", and the badge is real everywhere,
     no further changes. Shapes accepted and failure behaviour are documented
     above fetchSupplier() in stock.js. A failed or malformed response hides
     the badge; it never falls back to a generated number.

     CORS: the endpoint must send Access-Control-Allow-Origin for
     https://bricksmart.store (the browser calls it directly). If the supplier
     API cannot do that, or needs a secret key, put a small Cloudflare Worker
     in front of it the way bricksmart-capi already is, and point `endpoint`
     at the Worker instead — the key stays server-side that way.         */
  endpoint: "",            /* <-- paste the stock URL here */
  key:      "sku",         /* "sku" (set number, e.g. 7005192) | "handle" | "pid" */
  batch:    false,         /* true = one call returns every item */
  cacheMs:  60000,         /* reuse a response this long */
  headers:  {},            /* extra request headers if the endpoint needs them */

  /* Real units per set. null = not counted yet = no badge rendered.
     Replace a null with a number and that set's badge goes live immediately. */
  counts: {
    "falcon":            null,
    "atat":              null,
    "minas":             null,
    "pokemon":           null,
    "colosseum":         null,
    "barad-dur":         null,
    "rivendell":         null,
    "death-star":        null,
    "sail-barge":        null,
    "star-destroyer":    null,
    "porsche-gt3rs":     null,
    "black-pearl":       null,
    "koenigsegg":        null,
    "mclaren-p1":        null,
    "red-bull-rb20":     null,
    "ferrari-sf24":      null,
    "porsche-911-rsr":   null,
    "gringotts":         null,
    "enterprise-d":      null,
    "mercedes-w14":      null,
    "bugatti-chiron":    null,
    "lamborghini-sian":  null,
    "ferrari-sp3":       null,
    "titanic":           null,
    "eiffel-tower":      null,
    "creel-house":       null,
    "upside-down":       null,
    "arkham-asylum":     null,
    "sanctum-sanctorum": null,
    "x-mansion":         null,
    "avengers-tower":    null,
    "daily-bugle":       null,
    "ewok-village":      null,
    "razor-crest":       null,
    "dropship-atot":     null,
    "porsche-911-targa": null,
    "venator":           null,
    "jango-starship":    null
  }
};

/* ---------------------------------------------------------------------------
   CART SOCIAL PROOF  (see social.js)
   mode "live" reads a real count from your own endpoint (set `endpoint`).
   mode "demo" shows a SEEDED PLACEHOLDER — the number is NOT REAL. Pre-launch
   only. There is no Shopify query for "carts containing this product", so live
   mode needs one small backend endpoint returning { "count": N }.
--------------------------------------------------------------------------- */
window.BM_SOCIAL_CONFIG = {
  /* WAS "demo" — generated cart-counts shown as real shopper activity.
     Off until there is a real number behind it. */
  mode: "off"
};

window.BM_SHOPIFY = {
  domain: "t18ma0-rd.myshopify.com",
  token:  "36dc6dfd3ca46280cb86960c1d677b9d",
  handles: {
    /* ---- all 38 verified present on t18ma0-rd, 2026-10-03 ---- */
    "falcon":            { single: "set-7005192", bundle: "set-7005192-bundle" },   /* SET 7005192 */
    "atat":              { single: "set-7005313", bundle: "set-7005313-bundle" },   /* SET 7005313 */
    "minas":             { single: "set-1001377", bundle: "set-1001377-bundle" },   /* SET 1001377 */
    "pokemon":           { single: "set-7002153", bundle: "set-7002153-bundle" },   /* SET 7002153 */
    "colosseum":         { single: "set-1000276", bundle: "set-1000276-bundle" },   /* SET 1000276 */
    "barad-dur":         { single: "set-1000333", bundle: "set-1000333-bundle" },   /* SET 1000333 */
    "rivendell":         { single: "set-1000316", bundle: "set-1000316-bundle" },   /* SET 1000316 */
    "death-star":        { single: "set-7005419", bundle: "set-7005419-bundle" },   /* SET 7005419 */
    "sail-barge":        { single: "set-7005397", bundle: "set-7005397-bundle" },   /* SET 7005397 */
    "star-destroyer":    { single: "set-7005252", bundle: "set-7005252-bundle" },   /* SET 7005252 */
    "porsche-gt3rs":     { single: "set-4002056", bundle: "set-4002056-bundle" },   /* SET 4002056 */
    "black-pearl":       { single: "set-1000365", bundle: "set-1000365-bundle" },   /* SET 1000365 */
    "koenigsegg":        { single: "set-4002232", bundle: "set-4002232-bundle" },   /* SET 4002232 */
    "mclaren-p1":        { single: "set-4002172", bundle: "set-4002172-bundle" },   /* SET 4002172 */
    "red-bull-rb20":     { single: "set-4002206", bundle: "set-4002206-bundle" },   /* SET 4002206 */
    "ferrari-sf24":      { single: "set-4002207", bundle: "set-4002207-bundle" },   /* SET 4002207 */
    "porsche-911-rsr":   { single: "set-4002096", bundle: "set-4002096-bundle" },   /* SET 4002096 */
    "gringotts":         { single: "set-7006417", bundle: "set-7006417-bundle" },   /* SET 7006417 */
    "enterprise-d":      { single: "set-1000356", bundle: "set-1000356-bundle" },   /* SET 1000356 */
    "mercedes-w14":      { single: "set-4002171", bundle: "set-4002171-bundle" },   /* SET 4002171 */
    "bugatti-chiron":    { single: "set-4002083", bundle: "set-4002083-bundle" },   /* SET 4002083 */

    "lamborghini-sian":  { single: "set-4002115", bundle: "set-4002115-bundle" },
    "ferrari-sp3":       { single: "set-4002143", bundle: "set-4002143-bundle" },
    "titanic":           { single: "set-1000294", bundle: "set-1000294-bundle" },
    "eiffel-tower":      { single: "set-1000307", bundle: "set-1000307-bundle" },
    "creel-house":       { single: "set-1001370", bundle: "set-1001370-bundle" },
    "upside-down":       { single: "set-7005810", bundle: "set-7005810-bundle" },
    "arkham-asylum":     { single: "set-7006300", bundle: "set-7006300-bundle" },
    "sanctum-sanctorum": { single: "set-7006218", bundle: "set-7006218-bundle" },
    "x-mansion":         { single: "set-7006294", bundle: "set-7006294-bundle" },
    "avengers-tower":    { single: "set-7006269", bundle: "set-7006269-bundle" },
    "daily-bugle":       { single: "set-7006178", bundle: "set-7006178-bundle" },
    "ewok-village":      { single: "set-1000236", bundle: "set-1000236-bundle" },
    "razor-crest":       { single: "set-7005331", bundle: "set-7005331-bundle" },
    "dropship-atot":     { single: "set-1000195", bundle: "" },   /* no bundle product in store */
    "porsche-911-targa": { single: "set-1000295", bundle: "set-1000295-bundle" },
    "venator":           { single: "set-7005367", bundle: "set-7005367-bundle" },
    "jango-starship":    { single: "set-7005409", bundle: "set-7005409-bundle" }
  }
};

/* ===== PHOENIX HOSTED CHECKOUT =====
   Phoenix hosts the checkout at checkout.bricksmartorder.store. Its page is
   generic: hand it the Shopify cart token + key plus the store id and it
   renders checkout for whatever that cart holds.

   THE KEY COMES FROM cart.id, NOT checkoutUrl.
     cart.id        -> gid://shopify/Cart/<token>?key=<32 hex>   <-- this one
     cart.checkoutUrl -> /cart/c/<token>?key=<156-char blob>     <-- NOT this
   Verified 2026-10-06 against a working link supplied by the merchant. */
window.BM_PHOENIX = {
  base:  "https://checkout.bricksmartorder.store/",
  store: "t18ma0-rd",

  /* ---- PRICE GUARD ----
     true  = refuse the handoff when the drawer total and the Shopify cart
             total disagree by more than a cent. THE SAFE SETTING.
     false = log the mismatch loudly and go to checkout anyway. A shopper can
             be charged more than the page advertised.
     Currently FALSE for diagnosis. SET BACK TO true BEFORE REAL TRAFFIC. */
  enforcePrice: false
};

/* LEGACY / FALLBACK CHECKOUT LINK MATRIX — retired 2026-08-19.
   The old static cart links were dead (Shopify redirects dead carts to the
   store homepage), so they are blanked. All checkout now goes through the
   live Storefront API above; on API failure the button shows a retry
   message instead of navigating anywhere. */
window.BM_CHECKOUT = {
  falcon: {
    single: { once: "",
              vip:  "" },
    bundle: { once: "",
              vip:  "" }
  },
  atat: {
    single: { once: "",
              vip:  "" },
    bundle: { once: "",
              vip:  "" }
  },
  minas: {
    single: { once: "",
              vip:  "" },
    bundle: { once: "",
              vip:  "" }
  },
  pokemon: {
    single: { once: "",
              vip:  "" },
    bundle: { once: "",
              vip:  "" }
  }
};

/*bm-tail-patched*/
